export default {
  version: "11.W.725-2025_05_24_05_18",
};
